(() => {
  const LeadFormBehavior = {
    initFormBindings() {
      if (this.formBindingsReady) return;
      this.formBindingsReady = true;

      this.minFillMs = 3000;
      this.maxAttempts = 3;
      this.retryBackoffMs = 800;
      this.openedBy = null;
      this.hashTriggersBound = false;

      this.form = this.querySelector('[data-lead-form]');
      this.submitBtn = this.querySelector('[data-submit-btn]');
      this.successClose = this.querySelector('[data-success-close]');

      if (this.form) {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }

      if (this.successClose) {
        this.successClose.addEventListener('click', () => this.hide());
      }

      if (this.localName !== 'lead-form-inline') this.bindHashTriggers();
    },

    isTriggerHash(hash) {
      const normalized = (hash || '').toLowerCase();
      return normalized === '#request' || normalized === '#leadformmodal' || normalized === '#lease-request';
    },

    isLeaseHash(hash) {
      return (hash || '').toLowerCase() === '#lease-request';
    },

    formLocationForHash(hash) {
      const n = (hash || '').toLowerCase();
      if (n === '#lease-request') return 'hash_lease_request';
      return n === '#request' ? 'hash_request' : 'hash_leadform_modal';
    },

    createHashOpener(hash) {
      const location = this.formLocationForHash(hash);
      return {
        _fromHash: true,
        getAttribute: (name) => (name === 'data-form-location' ? location : null),
        focus: () => {}
      };
    },

    clearTriggerHash() {
      if (!this.isTriggerHash(window.location.hash)) return;
      history.replaceState({}, '', window.location.pathname + window.location.search);
    },

    bindHashTriggers() {
      if (this.hashTriggersBound) return;
      this.hashTriggersBound = true;

      this.onHashChange = () => {
        const hash = window.location.hash;
        if (this.isTriggerHash(hash)) {
          if (!this.open) {
            this.show(this.createHashOpener(hash));
          }
          return;
        }

        if (this.open && this.openedBy && this.openedBy._fromHash) {
          this.hide();
        }
      };

      this.onHashLinkClick = (event) => {
        const link = event.target.closest('a[href="#request"], a[href="#leadformmodal"], a[href="#LeadFormModal"], a[href="#lease-request"]');
        if (!link) return;

        if (link.hasAttribute('aria-controls')) return;

        const href = (link.getAttribute('href') || '').toLowerCase();
        if (!this.isTriggerHash(href)) return;

        event.preventDefault();

        const opener = link.getAttribute('data-form-location') ? link : this.createHashOpener(href);
        if (window.location.hash.toLowerCase() !== href) {
          history.pushState(null, '', href);
        }

        if (!this.open) {
          this.show(opener);
        }
      };

      window.addEventListener('hashchange', this.onHashChange);
      document.addEventListener('click', this.onHashLinkClick, true);
      this.onHashChange();
    },

    prepareLeadFormShow() {
      this.resetState();
      this.populateMetadata(this._pendingOpener);
      this.applyMode();
      this.openedBy = this._pendingOpener;
    },

    applyMode(forceMode) {
      if (!this.form) return;
      const isLease = forceMode ? forceMode === 'lease' : this.isLeaseHash(window.location.hash);

      const reqType = this.form.querySelector('input[name="request_type"]');
      if (reqType) reqType.value = isLease ? 'lease' : '';

      this.querySelectorAll('[data-lease-only]').forEach((el) => { el.hidden = !isLease; });
      const term = this.form.querySelector('[name="lease_term"]');
      if (term) {
        if (isLease) {
          term.setAttribute('required', '');
          term.setAttribute('aria-required', 'true');
        } else {
          term.removeAttribute('required');
          term.removeAttribute('aria-required');
          term.value = '';
        }
      }

      const heading = this.querySelector('#LeadFormOverlay-Heading');
      if (heading) {
        if (this._defaultHeading == null) this._defaultHeading = heading.textContent;
        heading.textContent = isLease ? 'Request Lease Info' : this._defaultHeading;
      }

      const p = (isLease && window.__dslrLeaseProduct) ? window.__dslrLeaseProduct : {};
      const setHidden = (name, val) => {
        const el = this.form.querySelector(`input[type="hidden"][name="${name}"]`);
        if (el) el.value = val || '';
      };
      setHidden('product_title', p.title);
      setHidden('product_sku', p.sku);
      setHidden('product_id', p.id != null ? String(p.id) : '');
    },

    cleanupLeadFormHide() {
      this.clearTriggerHash();
      this.resetFormOnClose();
      this.applyMode('quote');
    },

    resetFormOnClose() {
      if (!this.form) return;
      this.form.reset();
      this.removeAttribute('data-state');
      if (this.submitBtn) {
        this.submitBtn.removeAttribute('data-loading');
        this.submitBtn.disabled = false;
      }
      this.clearValidationErrors();
      const errorBanner = this.querySelector('[data-error-banner]');
      const successPanel = this.querySelector('[data-success-panel]');
      if (errorBanner) errorBanner.hidden = true;
      if (successPanel) successPanel.hidden = true;
    },

    resetState() {
      if (!this.form) return;
      this.form.reset();
      this.removeAttribute('data-state');
      if (this.submitBtn) {
        this.submitBtn.removeAttribute('data-loading');
        this.submitBtn.disabled = false;
      }
      this.clearValidationErrors();
      const errorBanner = this.querySelector('[data-error-banner]');
      const successPanel = this.querySelector('[data-success-panel]');
      if (errorBanner) errorBanner.hidden = true;
      if (successPanel) successPanel.hidden = true;
    },

    clearValidationErrors() {
      this.querySelectorAll('[data-field-invalid]').forEach((el) => {
        el.removeAttribute('data-field-invalid');
      });
      if (!this.form) return;
      this.form.querySelectorAll('[aria-invalid]').forEach((el) => {
        el.removeAttribute('aria-invalid');
      });
    },

        storedAdParams() {
      try {
        return JSON.parse(localStorage.getItem('euas_ad_params') || '{}') || {};
      } catch (e) {
        return {};
      }
    },

    populateMetadata(trigger) {
      if (!this.form) return;

      const params = new URLSearchParams(window.location.search);
      const stored = this.storedAdParams();
      const set = (name, value) => {
        const el = this.form.querySelector(`input[type="hidden"][name="${name}"]`);
        if (el) el.value = value || '';
      };
      // Live URL param wins; fall back to the value captured on landing.
      const resolve = (key) => params.get(key) || stored[key] || '';

      set('utm_source', resolve('utm_source'));
      set('utm_medium', resolve('utm_medium'));
      set('utm_campaign', resolve('utm_campaign'));
      set('utm_term', resolve('utm_term'));
      set('utm_content', resolve('utm_content'));
      set('gclid', resolve('gclid'));
      set('page_url', window.location.href);
      set('form_location', (trigger && trigger.getAttribute('data-form-location')) || 'unspecified');
      set('form_load_timestamp', String(Date.now()));
    },

    validate(values) {
      const isLease = values.request_type === 'lease';
      let firstInvalid = null;

      ['full_name', 'email', 'company', 'phone', 'lease_term'].forEach((name) => {
        const wrapper = this.form.querySelector(`[data-field="${name}"]`);
        const input = this.form.querySelector(`[name="${name}"]`);
        if (wrapper) wrapper.removeAttribute('data-field-invalid');
        if (input) input.removeAttribute('aria-invalid');
      });

      const fail = (name) => {
        const wrapper = this.form.querySelector(`[data-field="${name}"]`);
        const input = this.form.querySelector(`[name="${name}"]`);
        if (wrapper) wrapper.setAttribute('data-field-invalid', '');
        if (input) input.setAttribute('aria-invalid', 'true');
        if (!firstInvalid) firstInvalid = name;
      };

      if (!values.full_name || values.full_name.trim().length < 2) fail('full_name');
      if (!values.email || !/^[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$/.test(values.email.trim())) fail('email');

      if (values.phone && values.phone.trim() !== '' && (values.phone.replace(/\D+/g, '')).length < 10) fail('phone');

      if (isLease) {
        if (!values.company || values.company.trim() === '') fail('company');
        if (!values.lease_term || values.lease_term.trim() === '') fail('lease_term');
      }

      if (firstInvalid) {
        const el = this.form.querySelector(`[name="${firstInvalid}"]`);
        if (el) el.focus();
        return false;
      }
      return true;
    },

    readForm() {
      const fd = new FormData(this.form);
      const out = {};
      fd.forEach((v, k) => { out[k] = typeof v === 'string' ? v : ''; });
      out.submitted_at = new Date().toISOString();
      return out;
    },

    showSuccess() {
      this.setAttribute('data-state', 'success');
      const errorBanner = this.querySelector('[data-error-banner]');
      const successPanel = this.querySelector('[data-success-panel]');
      if (errorBanner) errorBanner.hidden = true;
      if (successPanel) successPanel.hidden = false;
      if (this.submitBtn) {
        this.submitBtn.removeAttribute('data-loading');
        this.submitBtn.disabled = false;
      }
      // Focus the panel, not the Close button, so screen readers announce the
      // message and no focus ring is drawn on the button after a mouse submit.
      if (successPanel) successPanel.focus();
    },

    showError() {
      this.setAttribute('data-state', 'error');
      const errorBanner = this.querySelector('[data-error-banner]');
      if (errorBanner) errorBanner.hidden = false;
      if (this.submitBtn) {
        this.submitBtn.removeAttribute('data-loading');
        this.submitBtn.disabled = false;
      }
    },

    fakeSuccess() {
      this.showSuccess();
    },

    pushDataLayerEvent(values, dealId) {
      try {
        window.dataLayer = window.dataLayer || [];
        const payload = {
          event: 'lead_form_submission',
          form_location: values.form_location || 'unspecified',
          industry: values.industry || '',
          utm_source: values.utm_source || '',
          utm_medium: values.utm_medium || '',
          utm_campaign: values.utm_campaign || '',
          utm_term: values.utm_term || '',
          utm_content: values.utm_content || ''
        };
        if (dealId) payload.deal_id = String(dealId);
        window.dataLayer.push(payload);
      } catch (e) { /* analytics is non-blocking */ }
    },

    resolveWebhookUrl(raw) {
      const trimmed = (raw || '').trim();
      if (!trimmed) return { ok: false, reason: 'empty' };

      let parsed;
      try {
        parsed = new URL(trimmed, window.location.origin);
      } catch (e) {
        return { ok: false, reason: 'invalid' };
      }

      if (!/^https?:$/i.test(parsed.protocol)) {
        return { ok: false, reason: 'invalid-protocol' };
      }

      if (parsed.origin === window.location.origin) {
        return { ok: false, reason: 'relative-to-store', resolved: parsed.href };
      }

      return { ok: true, url: parsed.href, host: parsed.hostname };
    },

    postWithRetry(url, payload, attempt) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify(payload),
        keepalive: true
      }).then(async (res) => {
        const rawText = await res.text();
        let data = {};
        try { data = rawText ? JSON.parse(rawText) : {}; } catch (e) { data = { _parseError: true, _rawPreview: rawText.slice(0, 200) }; }
        if (res.ok) return data;
        const err = new Error('HTTP ' + res.status);
        err.httpStatus = res.status;
        throw err;
      }).catch((err) => {
        const shouldRetry = attempt < this.maxAttempts && (!err.httpStatus || err.httpStatus >= 500);
        if (shouldRetry) {
          return new Promise((resolve) => {
            setTimeout(resolve, this.retryBackoffMs * attempt);
          }).then(() => this.postWithRetry(url, payload, attempt + 1));
        }
        throw err;
      });
    },

    handleSubmit(event) {
      event.preventDefault();
      if (this.submitBtn.disabled) return;
      const values = this.readForm();

      if (!this.validate(values)) return;

      if (values.company_website && values.company_website.trim() !== '') {
        this.fakeSuccess();
        return;
      }

      const openedAt = parseInt(values.form_load_timestamp || '0', 10);
      if (!openedAt || (Date.now() - openedAt) < this.minFillMs) {
        this.fakeSuccess();
        return;
      }

      const webhookRaw = this.getAttribute('data-webhook-url') || '';
      const webhookCheck = this.resolveWebhookUrl(webhookRaw);
      if (!webhookCheck.ok) {
        console.error('[lead-form] Invalid webhook URL in theme settings:', webhookCheck.reason, webhookRaw);
        this.showError();
        return;
      }

      const webhook = webhookCheck.url;

      delete values.company_website;
      delete values.form_load_timestamp;
      // Keep quote-mode payloads unchanged: only lease submissions carry these.
      if (!values.request_type) delete values.request_type;
      if (!values.lease_term) delete values.lease_term;
      if (!values.product_title) delete values.product_title;
      if (!values.product_sku) delete values.product_sku;
      if (!values.product_id) delete values.product_id;

      this.submitBtn.setAttribute('data-loading', '');
      this.submitBtn.disabled = true;
      this.removeAttribute('data-state');
      const errorBanner = this.querySelector('[data-error-banner]');
      if (errorBanner) errorBanner.hidden = true;

      this.postWithRetry(webhook, values, 1)
        .then((data) => {
          this.pushDataLayerEvent(values, data && data.deal_id);
          this.showSuccess();
        })
        .catch((err) => {
          console.error('[lead-form] Submission failed after retries:', err);
          this.showError();
        });
    }
  };

  const applyLeadFormBehavior = (Base) => {
    class LeadFormElement extends Base {
      constructor() {
        super();
      }

      connectedCallback() {
        super.connectedCallback();
        this.initFormBindings();
      }

      beforeShow() {
        this.prepareLeadFormShow();
        super.beforeShow();
      }

      afterHide() {
        super.afterHide();
        this.cleanupLeadFormHide();
      }

      show(activeElement = null, animate = true) {
        this._pendingOpener = activeElement;
        return super.show(activeElement, animate);
      }

      get shouldLock() {
        return true;
      }
    }

    Object.assign(LeadFormElement.prototype, LeadFormBehavior);
    return LeadFormElement;
  };

  class LeadFormInline extends HTMLElement {
    connectedCallback() {
      this.initFormBindings();
      this.resetInlineForm();
    }

    resetInlineForm() {
      this.resetState();
      this.populateMetadata(this);
      this.applyMode(this.getAttribute('data-request-mode') || 'quote');
    }

    hide() {
      this.resetInlineForm();
      const firstInput = this.form.querySelector('[name="full_name"]');
      if (firstInput) firstInput.focus();
    }
  }

  Object.assign(LeadFormInline.prototype, LeadFormBehavior);

  if (!customElements.get('lead-form-inline')) {
    customElements.define('lead-form-inline', LeadFormInline);
  }

  if (!customElements.get('lead-form-popup')) {
    customElements.define('lead-form-popup', applyLeadFormBehavior(ModalElement));
  }

  if (!customElements.get('lead-form-drawer')) {
    customElements.define('lead-form-drawer', applyLeadFormBehavior(DrawerElement));
  }
})();
